import React, { useEffect, useState } from "react";
import { Col, Form, Row, Tab, Tabs } from "react-bootstrap";

import ManageTableWithDynamicPagination from "../../Components/TableTemplate/ManageTableWithDynamicPagination";
import Navbar from "../../Components/Navbar/Navbar";
import DeleteModal from "../../Components/Modals/DeleteModal";
import AddModal from "../../Components/Modals/AddModal";
import EditModal from "../../Components/Modals/EditModal";
import ViewModal from "../../Components/Modals/ViewModal";

import "./Manage.css";
import "../../Components/Navbar/Navbar.css";

import {
  createBranch,
  deleteBranch,
  searchBranch,
  updateBranch,
} from "../../Helpers/apiCalls/Manage/Branches";
import toast from "react-hot-toast";
import Select from "react-select";
import {
  toastStyle,
  refreshPage,
  numberFormat,
  getType,
  getBranchId,
} from "../../Helpers/Utils/Common";
import { validateBranches } from "../../Helpers/Validation/Manage/BanchesValidation";
import InputError from "../../Components/InputError/InputError";
import ReactDatePicker from "react-datepicker";
import { getAllPriceLevels } from "../../Helpers/apiCalls/Manage/PriceLevels";
import { useNavigate } from "react-router-dom";
import { getAllBranchGroup } from "../../Helpers/apiCalls/Manage/BranchGroupApi";
import { getAllInventoryGroup } from "../../Helpers/apiCalls/Manage/InventoryGroup";
import { getAllEmployees } from "../../Helpers/apiCalls/employeesApi";
import Footer from "../../Components/Footer/Footer";
import { getTime } from "date-fns";

export default function Branches() {
  const [inactive, setInactive] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [option, setOption] = useState("Select");
  const [isClicked, setIsClicked] = useState(false);
  const [selectedType, setSelectedType] = useState("");
  let navigate = useNavigate();
  const [addTo, setAddTo] = useState("M");
  const accountType = getType();
  const withOutEdit =
    accountType === "admin" ||
    accountType === "hr_officer" ||
    accountType === "operations_manager" ||
    accountType === "purchasing_officer" ||
    accountType === "franchise_officer"
      ? false
      : true;

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const handleShowDeleteModal = () => setShowDeleteModal(true);
  const handleCloseDeleteModal = () => setShowDeleteModal(false);

  const [showViewBranchModal, setShowViewBranchModal] = useState(false);
  const handleShowViewBranchModal = () => setShowViewBranchModal(true);
  const handleCloseViewBranchModal = () => setShowViewBranchModal(false);

  const [showEditBranchModal, setShowEditBranchModal] = useState(false);
  const handleShowEditBranchModal = () => setShowEditBranchModal(true);
  const handleCloseEditBranchModal = () => setShowEditBranchModal(false);

  const [showAddBranchModal, setShowAddBranchModal] = useState(false);
  const handleShowAddBranchModal = () => setShowAddBranchModal(true);
  const handleCloseAddBranchModal = () => {
    setAddTo("");
    setShowAddBranchModal(false);
  };

  const [branchesData, setBranchesData] = useState([]);
  const [branchGroup, setBranchGroup] = useState([]);
  const [inventoryGroup, setInventoryGroup] = useState([]);
  const [filterConfig, setFilterConfig] = useState({
    name: "",
    tab: "",
    is_franchise: "0,1,2",
    page: 1,
  });

const [totalItems, setTotalItems] = useState(0);
const [currentPage, setCurrentPage] = useState(1);
const itemsPerPage = 10; // Change this based on your requirement

const handlePageChange = page => {
    setCurrentPage(page);
    setFilterConfig(prev => ({
    ...prev,
    page: page,
    }));
};

  const [selectedRow, setSelectedRow] = useState({
    name: "",
    address: "",
    contact_person_no: "",
    phone_no: "",
    tin_no: "",
    bir_no: "",
    franchisee_name: "",
    franchisee_contact_no: "",
    contract_start: "",
    contract_end: "",
    opening_date: "",
    price_level: "",
    contact_person: "",
  });
  const [priceLevel, setPriceLevels] = useState([]);
  const [allOIC, setAllOIC] = useState([]);
  const [allIcc, setAllIcc] = useState([]);

  const [isError, setIsError] = useState({
    name: false,
    address: false,
    // inventory_group_id: false,
    phone_no: false,
    initial_drawer: false,
    price_level: false,
    contact_person: false,
    contact_person_no: false,
    is_franchise: false,
    rental_monthly_fee: false,
    opening_date: false,
  });

  const [isErrorEdit, setIsErrorEdit] = useState({
    name: false,
    address: false,
    inventory_group_id: false,
    phone_no: false,
    initial_drawer: false,
    price_level: false,
    contact_person: false,
    contact_person_no: false,
    is_franchise: false,
    rental_monthly_fee: false,
    opening_date: false,
  });

  const [osStartTime, setOsStartTime] = useState(new Date());
  const [osEndTime, setOsEndTime] = useState(new Date());

  const [deliveryStartTime, setDeliveryStartTime] = useState(new Date());
  const [deliveryEndTime, setDeliveryEndTime] = useState(new Date());

  const [osStartTimeEdit, setOsStartTimeEdit] = useState(new Date());
  const [osEndTimeEdit, setOsEndTimeEdit] = useState(new Date());

  const [deliveryStartTimeEdit, setDeliveryStartTimeEdit] = useState(
    new Date()
  );
  const [deliveryEndTimeEdit, setDeliveryEndTimeEdit] = useState(new Date());

  const [addBranchData, setAddBranchData] = useState({
    name: "",
    address: "",
    phone_no: "",
    status: "active",
    inventory_group_id: "",
    contact_person_no: "",
    rental_monthly_fee: "",
    tin_no: "",
    bir_no: "",
    franchisee_name: "",
    franchisee_contact_no: "",
    contract_start: "",
    contract_end: "",
    opening_date: "",
    price_level: "",
    contact_person: "",
    initial_drawer: "",
    os_startDate: "monday",
    os_endDate: "sunday",
    os_startTime: "",
    os_endTime: "",
    delivery_startDate: "monday",
    delivery_endDate: "sunday",
    delivery_startTime: "",
    delivery_endTime: "",
    is_franchise: "",
    deposit_method: "",
    bank_for_deposit: "",
  });

  const [editBranchData, setEditBranchData] = useState({
    id: "",
    name: "",
    address: "",
    phone_no: "",
    contact_person_no: "",
    inventory_group_id: "",
    rental_monthly_fee: "",
    tin_no: "",
    bir_no: "",
    franchisee_name: "",
    franchisee_contact_no: "",
    contract_start: "",
    contract_end: "",
    opening_date: "",
    price_level: "",
    contact_person: "",
    operation_schedule: "",
    delivery_schedule: "",
    is_franchise: "",
  });

  const handleEditChange = (e, type) => {
    if(type === "select") {
        setEditBranchData((prevState) => ({
            ...prevState,
            [e.for]: e.value,
            [e.for_name]: e.label,
            [e.select_value]: {
                for: e.for,
                label: e.label,
                value: e.value,
            }
        }));
    } else {
      const { name, value } = e.target;

      setEditBranchData((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };

  const handleAddChange = (e, type) => {
    if(type === "select") {
        setAddBranchData((prevState) => ({
            ...prevState,
            [e.for]: e.value,
            [e.for_name]: e.label,
            [e.select_value]: {
                for: e.for,
                label: e.label,
                value: e.value,
            }
        }));
    } else {
      const { name, value } = e.target;

      setAddBranchData((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilterConfig((prev) => {
      return { ...prev, [name]: value };
    });
  };

  const handleTabSelect = (tabKey) => {
    setFilterConfig((prev) => {
      return { ...prev, tab: tabKey, name: "", is_franchise: "0,1,2" };
    });
  };

  async function fetchInventoryGroup() {
    setShowLoader(true);
    setInventoryGroup([]);
    const response = await getAllInventoryGroup({});
    if (response.data) {
      var result = response.data.data;
      var mangoInventory = result.map((inventory) => {
        return {
          type: "",
          id: inventory.id,
          name: inventory.name,
        };
      });
      setInventoryGroup(mangoInventory);
    } else if (response.error) {
    }
    setShowLoader(false);
  }

  async function fetchPriceLevel() {
    setShowLoader(true);
    setPriceLevels([]);
    const response = await getAllPriceLevels();

    if (response) {
      setPriceLevels(response.data.data);
    }
    setShowLoader(false);
  }

  function handleOnSearch(e) {
    const { name, value } = e.target;
    setFilterConfig((prev) => {
      return { ...prev, [name]: value };
    });
  }

  async function searchBranches() {
    setShowLoader(true);
    setBranchesData([]);
    setTotalItems(0);

    const response = await searchBranch(filterConfig);
    if (response.data) {
      var result = response.data.data;
      var mangoBranches = result
        .filter((data) => {
          return data.id !== "71";
        })
        .map((branch) => {
          return {
            ...branch,
            type: "",
            branch_id: branch.id,
            branch_name: branch.name,
            address: branch.address,
            status: branch.status,
            phone_number: branch.contact_person_no || branch.phone_no,
            initial_cash: branch.initial_drawer,
            branch_type:
              branch.is_franchise === "0"
                ? "Company-owned"
                : branch.is_franchise === "1"
                ? "Franchise Branch"
                : "Others",
            action_btn: ActionBtn(branch, ""),
          };
        });
        if(accountType === "branch_oic" || accountType === "branch_inventory_officer") {
          var data = mangoBranches.filter((data) => {
            return data.branch_id === getBranchId()
          })
          setBranchesData(data);
        } else {
          setBranchesData(mangoBranches);
        }
        setTotalItems(response.data.size);
    }

    setShowLoader(false);
  }

  async function create() {
    if (validateBranches(addBranchData, setIsError, addTo)) {
      setIsClicked(true);
      const response = await createBranch(addBranchData, {
        osStartTime: osStartTime,
        osEndTime: osEndTime,
        // deliveryStartTime: deliveryStartTime,
        // deliveryEndTime: deliveryEndTime,
      });
      if (response.data) {
          toast.success(response.data.message, { style: toastStyle() });
          setTimeout(() => {
            refreshPage()
          }, 1000);
      } else {
          response.error?.response?.data?.messages.map((data) => {
              return toast.error(data);
          })
          setTimeout(() => {
            refreshPage()
          }, 1000);
      }
    }
  }

  async function handleDeleteBranch() {
    setIsClicked(true);
    const response = await deleteBranch(selectedRow.id);
    if (response) {
      if (response.data) {
        toast.success(response.data.message, {
          style: toastStyle(),
        });
        setTimeout(() => refreshPage(), 1000);
      } else {
        response.error?.response?.data?.messages.map((data) => {
          return toast.error(data);
        })
        setTimeout(() => refreshPage(), 1000);
      }
    } else {
      response.error?.response?.data?.messages.map((data) => {
        return toast.error(data);
      })
        setTimeout(() => refreshPage(), 1000);
    }
  }

  async function editBranch() {
    if (validateBranches(editBranchData, setIsErrorEdit, addTo)) {
      setIsClicked(true);
      const response = await updateBranch(editBranchData, {
        osStartTime: osStartTimeEdit,
        osEndTime: osEndTimeEdit,
        // deliveryStartTime: deliveryStartTimeEdit,
        // deliveryEndTime: deliveryEndTimeEdit,
      });

      if (response.data) {
        toast.success(response.data.message, {
          style: toastStyle(),
        });
        setTimeout(() => refreshPage(), 1000);
      } else {
          response.error?.response?.data?.messages.map((data) => {
            return toast.error(data);
          })
          setTimeout(() => refreshPage(), 1000);
      }
    }
  }

  function handleSelectChange(e, row, type) {
    setSelectedRow(row);
    setSelectedType(type);
    setEditBranchData(row);

    if (e.target.value === "delete-branch") {
      handleShowDeleteModal();
    } else if (e.target.value === "edit-branch") {
      if (row.operation_days !== "") {
        var OsSchedule = row.operation_days?.split("-");

        if (OsSchedule.length === 2) {
          row.os_startDate = OsSchedule[0];
          row.os_endDate = OsSchedule[1];

          if (row.operation_times !== null && row.operation_times !== "") {
            var OsTime = row.operation_times?.split("-");
            var start = new Date();
            start.setHours(OsTime[0].split(":")[0], OsTime[0].split(":")[1]);
            var end = new Date();
            end.setHours(OsTime[1].split(":")[0], OsTime[1].split(":")[1]);

            setOsStartTimeEdit(start);
            setOsEndTimeEdit(end);
          }
          if (row.operation_times !== null && row.operation_times !== "") {
            var deliverySchedule = row.delivery_days?.split("-");
            row.delivery_startDate = deliverySchedule[0];
            row.delivery_endDate = deliverySchedule[1];

            var deliveryTime = row.delivery_times?.split("-");
            var deliverstart = new Date();
            if (deliveryTime !== undefined) {
              deliverstart.setHours(
                deliveryTime[0].split(":")[0],
                deliveryTime[0].split(":")[1]
              );
              var deliverend = new Date();
              deliverend.setHours(
                deliveryTime[1].split(":")[0],
                deliveryTime[1].split(":")[1]
              );
            }

            setDeliveryStartTimeEdit(deliverstart);
            setDeliveryEndTimeEdit(deliverend);
          }
        } else {
          row.os_startDate =
            OsSchedule[0] !== "undefined"
              ? OsSchedule[0]
              : OsSchedule[1].split(" ")[0];
          row.os_endDate =
            OsSchedule[2] !== "undefined"
              ? OsSchedule[2]
              : OsSchedule[3].split(" ")[0];

          if (OsSchedule[0] === "undefined" || OsSchedule[2] === "undefined") {
            switch (OsSchedule[1].split(" ")[0]) {
              case "Mon":
                row.os_startDate = "monday";
                break;
              case "Tue":
                row.os_startDate = "tuesday";
                break;
              case "Wed":
                row.os_startDate = "wednesday";
                break;
              case "Thu":
                row.os_startDate = "thursday";
                break;
              case "Fri":
                row.os_startDate = "friday";
                break;
              case "Sat":
                row.os_startDate = "saturday";
                break;
              case "Sun":
                row.os_startDate = "sunday";
                break;
              default:
                break;
            }

            switch (OsSchedule[3].split(" ")[0]) {
              case "Mon":
                row.os_endDate = "monday";
                break;
              case "Tue":
                row.os_endDate = "tuesday";
                break;
              case "Wed":
                row.os_endDate = "wednesday";
                break;
              case "Thu":
                row.os_endDate = "thursday";
                break;
              case "Fri":
                row.os_endDate = "friday";
                break;
              case "Sat":
                row.os_endDate = "saturday";
                break;
              case "Sun":
                row.os_endDate = "sunday";
                break;
              default:
                break;
            }
          }

          const start = new Date(OsSchedule[1]);
          const end = new Date(OsSchedule[3]);

          setOsStartTimeEdit(start);
          setOsEndTimeEdit(end);
        }
      }

      if (row.delivery_days !== "") {
        const deliverySchedule = row.delivery_days.split("-");

        if (deliverySchedule.length > 2) {
          row.delivery_startDate =
            deliverySchedule[0] !== "undefined"
              ? deliverySchedule[0]
              : deliverySchedule[1].split(" ")[0];
          setDeliveryStartTimeEdit(new Date(deliverySchedule[1]));
          row.delivery_endDate =
            deliverySchedule[2] !== "undefined"
              ? deliverySchedule[2]
              : deliverySchedule[3].split(" ")[0];
          setDeliveryEndTimeEdit(new Date(deliverySchedule[3]));

          if (
            deliverySchedule[0] === "undefined" ||
            deliverySchedule[2] === "undefined"
          ) {
            switch (deliverySchedule[1].split(" ")[0]) {
              case "Mon":
                row.delivery_startDate = "monday";
                break;
              case "Tue":
                row.delivery_startDate = "tuesday";
                break;
              case "Wed":
                row.delivery_startDate = "wednesday";
                break;
              case "Thu":
                row.delivery_startDate = "thursday";
                break;
              case "Fri":
                row.delivery_startDate = "friday";
                break;
              case "Sat":
                row.delivery_startDate = "saturday";
                break;
              case "Sun":
                row.delivery_startDate = "sunday";
                break;
              default:
                break;
            }

            switch (deliverySchedule[3].split(" ")[0]) {
              case "Mon":
                row.delivery_endDate = "monday";
                break;
              case "Tue":
                row.delivery_endDate = "tuesday";
                break;
              case "Wed":
                row.delivery_endDate = "wednesday";
                break;
              case "Thu":
                row.delivery_endDate = "thursday";
                break;
              case "Fri":
                row.delivery_endDate = "friday";
                break;
              case "Sat":
                row.delivery_endDate = "saturday";
                break;
              case "Sun":
                row.delivery_endDate = "sunday";
                break;
              default:
                break;
            }
          }

          const start = new Date(deliverySchedule[1]);

          const end = new Date(deliverySchedule[3]);

          setDeliveryStartTimeEdit(start);
          setDeliveryEndTimeEdit(end);
        }
      }

      setEditBranchData(row);
      handleShowEditBranchModal();
    } else if (e.target.value === "view-branch") {
      handleShowViewBranchModal();
    } else {
      handleShowDeleteModal();
    }
  }

  async function fetchEmployees() {
      setAllIcc([]);
      setAllOIC([]);
      const response = await getAllEmployees();
      if(response.data) {
          var arrayResponse = [...response.data.data]
          var data = arrayResponse.map((data) => {
              var info = {};
              info.for = "icc_id";
              info.for_name = "icc_name";
              info.select_value = "employee_id_value";
              info.label = data.first_name + " " + data.last_name;
              info.value = data.id;
              return info
          })
          setAllIcc(data);


          var oic = arrayResponse
          // .filter((data) => { return data.employee_type === "officer in charge"})
          .map((data) => {
              var info = {};
              info.for = "oic_id";
              info.for_name = "oic_name";
              info.select_value = "oic_id_value";
              info.label = data.first_name + " " + data.last_name;
              info.value = data.id;
              return info
          })
          setAllOIC(oic);
      }
  }

  function ActionBtn(row, type) {
    return (
      <Form.Select
        name="action"
        className="PO-select-action"
        id={row}
        onChange={(e) => handleSelectChange(e, row, type)}
        value={option}
      >
        <option defaulValue selected hidden>
          Select
        </option>
        <option value="view-branch" className="color-options">
          View
        </option>
        {(accountType === "admin" ||
          accountType === "branch_inventory_officer" ||
          accountType === "branch_oic") && (
          <option value="edit-branch" className="color-options">
            Edit
          </option>
        )}
        {/* <option value="update-status" className="color-options">
                    Update Status
                </option> */}
        {(accountType === "admin" ||
          accountType === "branch_inventory_officer" ||
          accountType === "branch_oic") && (
          <option value="delete-branch" className="color-red">
            Delete
          </option>
        )}
      </Form.Select>
    );
  }

  function handleOnEdit() {
    var row = selectedRow;
    if (row.operation_days !== "") {
      var OsSchedule = row.operation_days.split("-");

      if (OsSchedule.length === 2) {
        row.os_startDate = OsSchedule[0];
        row.os_endDate = OsSchedule[1];

        var OsTime = row.operation_times?.split("-");
        var startHours = parseInt(OsTime[0].slice(0, 2), 10); //get the start hour 
        var startMinutes = parseInt(OsTime[0].slice(3, 5), 10) //get the start minutes
        var endHours = parseInt(OsTime[1].slice(0, 2), 10); //get the end hours
        var endMinutes = parseInt(OsTime[1].slice(3, 5), 10) //get the end minutes

        if(OsTime[0].slice(-2) === "pm") { //add 12 if the time is pm
          startHours+=12
        } else if(OsTime[1].slice(-2) === "pm") {
          endHours+=12
        }

        var start = new Date();
        start.setHours(startHours, startMinutes);
        var end = new Date();
        end.setHours(endHours, endMinutes);
        setOsStartTimeEdit(start);
        setOsEndTimeEdit(end);

        // var deliverySchedule = row.delivery_days?.split("-");
        // row.delivery_startDate = deliverySchedule[0];
        // row.delivery_endDate = deliverySchedule[1];

        // var deliveryTime = row?.delivery_times?.split("-");
        // var deliverstart = new Date();
        // deliverstart.setHours(
        //   deliveryTime[0].split(":")[0],
        //   deliveryTime[0].split(":")[1]
        // );
        // var deliverend = new Date();
        // deliverend.setHours(
        //   deliveryTime[1]?.split(":")[0],
        //   deliveryTime[1]?.split(":")[1]
        // );

        // setDeliveryStartTimeEdit(deliverstart);
        // setDeliveryEndTimeEdit(deliverend);
      } else {
        row.os_startDate =
          OsSchedule[0] !== "undefined"
            ? OsSchedule[0]
            : OsSchedule[1].split(" ")[0];
        row.os_endDate =
          OsSchedule[2] !== "undefined"
            ? OsSchedule[2]
            : OsSchedule[3].split(" ")[0];

        if (OsSchedule[0] === "undefined" || OsSchedule[2] === "undefined") {
          switch (OsSchedule[1].split(" ")[0]) {
            case "Mon":
              row.os_startDate = "monday";
              break;
            case "Tue":
              row.os_startDate = "tuesday";
              break;
            case "Wed":
              row.os_startDate = "wednesday";
              break;
            case "Thu":
              row.os_startDate = "thursday";
              break;
            case "Fri":
              row.os_startDate = "friday";
              break;
            case "Sat":
              row.os_startDate = "saturday";
              break;
            case "Sun":
              row.os_startDate = "sunday";
              break;
            default:
              break;
          }

          switch (OsSchedule[3].split(" ")[0]) {
            case "Mon":
              row.os_endDate = "monday";
              break;
            case "Tue":
              row.os_endDate = "tuesday";
              break;
            case "Wed":
              row.os_endDate = "wednesday";
              break;
            case "Thu":
              row.os_endDate = "thursday";
              break;
            case "Fri":
              row.os_endDate = "friday";
              break;
            case "Sat":
              row.os_endDate = "saturday";
              break;
            case "Sun":
              row.os_endDate = "sunday";
              break;
            default:
              break;
          }
        }

        const start = new Date(OsSchedule[1]);
        const end = new Date(OsSchedule[3]);
        setOsStartTimeEdit(start);
        setOsEndTimeEdit(end);
      }
    }

    // if (row.delivery_days !== "") {
    //   const deliverySchedule = row.delivery_days.split("-");

    //   if (deliverySchedule.length > 2) {
    //     row.delivery_startDate =
    //       deliverySchedule[0] !== "undefined"
    //         ? deliverySchedule[0]
    //         : deliverySchedule[1].split(" ")[0];
    //     setDeliveryStartTimeEdit(new Date(deliverySchedule[1]));
    //     row.delivery_endDate =
    //       deliverySchedule[2] !== "undefined"
    //         ? deliverySchedule[2]
    //         : deliverySchedule[3].split(" ")[0];
    //     setDeliveryEndTimeEdit(new Date(deliverySchedule[3]));

    //     if (
    //       deliverySchedule[0] === "undefined" ||
    //       deliverySchedule[2] === "undefined"
    //     ) {
    //       switch (deliverySchedule[1].split(" ")[0]) {
    //         case "Mon":
    //           row.delivery_startDate = "monday";
    //           break;
    //         case "Tue":
    //           row.delivery_startDate = "tuesday";
    //           break;
    //         case "Wed":
    //           row.delivery_startDate = "wednesday";
    //           break;
    //         case "Thu":
    //           row.delivery_startDate = "thursday";
    //           break;
    //         case "Fri":
    //           row.delivery_startDate = "friday";
    //           break;
    //         case "Sat":
    //           row.delivery_startDate = "saturday";
    //           break;
    //         case "Sun":
    //           row.delivery_startDate = "sunday";
    //           break;
    //         default:
    //           break;
    //       }

    //       switch (deliverySchedule[3].split(" ")[0]) {
    //         case "Mon":
    //           row.delivery_endDate = "monday";
    //           break;
    //         case "Tue":
    //           row.delivery_endDate = "tuesday";
    //           break;
    //         case "Wed":
    //           row.delivery_endDate = "wednesday";
    //           break;
    //         case "Thu":
    //           row.delivery_endDate = "thursday";
    //           break;
    //         case "Fri":
    //           row.delivery_endDate = "friday";
    //           break;
    //         case "Sat":
    //           row.delivery_endDate = "saturday";
    //           break;
    //         case "Sun":
    //           row.delivery_endDate = "sunday";
    //           break;
    //         default:
    //           break;
    //       }
    //     }

    //     const start = new Date(deliverySchedule[1]);
    //     const end = new Date(deliverySchedule[3]);

    //     setDeliveryStartTimeEdit(start);
    //     setDeliveryEndTimeEdit(end);
    //   }
    // }

    setEditBranchData(row);

    handleCloseViewBranchModal();
    handleShowEditBranchModal();
  }

  function renderBranchType(type) {
    switch (type) {
      case "0":
        return `BRANCH DETAILS (Company-owned branch)`;
      case "1":
        return `BRANCH DETAILS (Franchise branch)`;
      default:
        return `BRANCH DETAILS`;
    }
  }

  useEffect(() => {
    searchBranches();
  }, [filterConfig, currentPage]);

  useEffect(() => {
    fetchPriceLevel();
    fetchInventoryGroup();
    fetchEmployees()
  }, [addTo, showEditBranchModal]);

  return (
    <div>
      <div className="page">
        <Navbar
          onCollapse={(inactive) => {
            setInactive(inactive);
          }}
          active={"MANAGE"}
        />
      </div>
      <div className={`manager-container ${inactive ? "inactive" : "active"}`}>
        <Row className="mb-4">
          <Col xs={12} lg={7}>
              <h1 className="page-title ps-2 ms-3 ms-md-0 ps-md-0 ms-md-0 fs-2"> BRANCHES </h1>
          </Col>
          <Col xs={12} lg={3} className="d-flex justify-content-end force-width flex-column flex-lg-row gap-3">
              <input
                  type="search"
                  name="name"
              className="search-bar"
              onKeyPress={(e) =>
                e.key === ("Enter" || "NumpadEnter") && handleFilterChange(e)
              }
              placeholder="Search branch name..."
              />
          </Col>
          <Col lg={2} className="mt-4 mt-lg-0">
              <div className="PO-filters">
                  {
                  (accountType !== "branch_oic" && accountType !== "branch_inventory_officer") && (
                    <button
                      className="add-btn"
                      eventKey="MANGO MAGIC"
                      onClick={handleShowAddBranchModal}
                    >
                      Add
                    </button>
                  )
                }
              </div>
          </Col>
        </Row>
        {/* TABLE */}
        {/* <Tabs
          activeKey={filterConfig.tab}
          defaultActiveKey={filterConfig.tab}
          id="suppliers-tabs"
          className="manager-tabs"
          onSelect={handleTabSelect}
        >
          <Tab eventKey="MANGO MAGIC" title="All"> */}
            <div className="tab-content">
              <div className="mb-3" />
              <span className="ps-3 mb-2 align-middle d-none d-md-inline d-flex text-secondary">
                  Filter By:
              </span>
              <Row className="PO-filters flex flex-row mx-2 my-1">
                <Col xs={12} lg={4} className="mb-2 mb-lg-0">
                <Form.Select
                  name="is_franchise"
                  className="date-filter me-2"
                  value={filterConfig.is_franchise}
                  onChange={(e) => handleOnSearch(e)}
                >
                  <option value="0,1,2" selected>
                    {" "}
                    All Branch Type{" "}
                  </option>
                  <option value="0"> Company Owned </option>
                  {/* <option value="1"> Franchise Branch </option> */}
                  <option value="2"> Others </option>
                </Form.Select>
                </Col>
              </Row>
              <div className="mb-2" />

              <ManageTableWithDynamicPagination
                tableHeaders={[
                  "BRANCH NAME",
                  "TYPE",
                  "ADDRESS",
                  "PHONE NUMBER",
                  "INITIAL CASH IN DRAWER",
                  "STATUS",
                  "ACTIONS",
                ]}
                headerSelector={[
                  "branch_name",
                  "branch_type",
                  "address",
                  "phone_number",
                  "initial_cash",
                  "status",
                  // "action_btn",
                ]}
                tableData={branchesData}
                showLoader={showLoader}
                // withActionData={true}
                ActionBtn={(row) => ActionBtn(row)}
                // used in dynamic pagination
                totalItems={totalItems}
                currentPage={currentPage}
                itemsPerPage={itemsPerPage}
                handlePageChange={handlePageChange}
              />
            </div>
          {/* </Tab>
        </Tabs> */}
      </div>
      {/* MODALS */}
      <DeleteModal
        text="branch"
        show={showDeleteModal}
        onHide={handleCloseDeleteModal}
        onDelete={() => handleDeleteBranch()}
        isClicked={isClicked}
      />
       <AddModal
        title={`BRANCH`}
        type="branch"
        show={showAddBranchModal}
        onHide={handleCloseAddBranchModal}
        onSave={() => create()}
        isProceed={addBranchData.is_franchise === "1" ? true : false}
        isClicked={isClicked}
      >
        <div className="mt-3">
          <Row className="mb-2">
            <Col xs={12} lg={3}>
              <span className="edit-label">
              BRANCH NAME
                  <span className="color-red"> *</span>
              </span>
              <Form.Control
                type="text"
                name="name"
                value={addBranchData.name}
                className="nc-modal-custom-input-edit"
                onChange={(e) => handleAddChange(e)}
                required
              />
              <InputError
                isValid={isError.name}
                message={"Branch name is required"}
              />
            </Col>
            <Col xs={12} lg={3} className="mt-2 mt-lg-0">
              <span className="edit-label">
              ADDRESS
                  <span className="color-red"> *</span>
              </span>
              <Form.Control
                type="text"
                name="address"
                value={addBranchData.address}
                className="nc-modal-custom-input-edit"
                onChange={(e) => handleAddChange(e)}
                required
              />
              <InputError
                isValid={isError.address}
                message={"Address is required"}
              />
            </Col>
            <Col xs={12} lg={3} className="mt-2 mt-lg-0">
              <span className="edit-label">
              PHONE NUMBER
                  <span className="color-red"> *</span>
              </span>
              <Form.Control
                type="text"
                name="phone_no"
                value={addBranchData.phone_no}
                className="nc-modal-custom-input-edit"
                onChange={(e) => handleAddChange(e)}
                required
              />
              <InputError
                isValid={isError.phone_no}
                message={"Phone number is required"}
              />
            </Col>
            <Col xs={12} lg={3} className="mt-2 mt-lg-0">
              <span className="edit-label">
              STATUS
              </span>
              <select
                className="nc-modal-custom-select"
                name="status"
                value={addBranchData.status}
                onChange={(e) => handleAddChange(e)}
              >
                <option value="" hidden>
                  Select
                </option>
                <option value="active">Active</option>
                <option value="inactive">Inactive</option>
              </select>
            </Col>
          </Row>
          <Row className="mb-2">
            <Col xs={12} lg={6}>
            <span className="edit-label">
            OIC
              </span>
              {/* <span className="required-icon">*</span> */}
              <Select
                  className="react-select-container"
                  classNamePrefix="react-select"
                  placeholder="Select OIC..."
                  value={addBranchData.oic_id_value}
                  options={allOIC}
                  onChange={(e) =>
                      handleAddChange(e, "select")
                  }
              />
            </Col>
            <Col xs={12} lg={6} className="mt-2 mt-lg-0">
            <span className="edit-label">
            ICC
              </span>
              {/* <span className="required-icon">*</span> */}
              <Select
                  className="react-select-container"
                  classNamePrefix="react-select"
                  placeholder="Select OIC..."
                  value={addBranchData.icc_id_value}
                  options={allIcc}
                  onChange={(e) =>
                      handleAddChange(e, "select")
                  }
              />
            </Col>
          </Row>
          {addTo !== "POTATO CORNER" && (
            <>
              <Row>
                <Col>
                  <span className="edit-label">
                  BRANCH TYPE
                  <span className="color-red"> *</span>
              </span>
                  <InputError
                    isValid={isError.is_franchise}
                    message={"Branch type is required"}
                  />
                </Col>
              </Row>
              <Row className="mb-2">
                {/* <Col xl={3} className="nc-modal-custom-row-details">
                  <input
                    type="radio"
                    name="is_franchise"
                    value="1"
                    className=""
                    onChange={(e) => handleAddChange(e)}
                    required
                  />
                  <span className="radio-label">FRANCHISE</span>
                </Col> */}
                <Col xl={3}>
                  <input
                    type="radio"
                    name="is_franchise"
                    value="0"
                    className=""
                    onChange={(e) => handleAddChange(e)}
                    required
                  />
                  <span className="radio-label">COMPANY-OWNED</span>
                </Col>
                <Col xl={3} className="nc-modal-custom-row-details">
                  <input
                    type="radio"
                    name="is_franchise"
                    value="2"
                    className=""
                    onChange={(e) => handleAddChange(e)}
                    required
                  />
                  <span className="radio-label">OTHERS</span>
                </Col>
              </Row>
            </>
          )}
          {addBranchData.is_franchise === "0" && (
            <Row className="mb-2">
              <Col>
                <span className="edit-label">
                MONTHLY RENTAL FEE
                  <span className="color-red"> *</span>
              </span>
                <Form.Control
                  type="text"
                  name="rental_monthly_fee"
                  value={addBranchData.rental_monthly_fee}
                  className="nc-modal-custom-input-edit"
                  onChange={(e) => handleAddChange(e)}
                  required
                />
                <InputError
                  isValid={isError.rental_monthly_fee}
                  message={"Monthly rental fee is required"}
                />
              </Col>
            </Row>
          )}
          {addBranchData.is_franchise !== "2" ? (
            <>
              <Row className="mb-2">
                {/* <Col>
                  CUPS TYPE
                  <Form.Select
                    name="type"
                    className="nc-modal-custom-input"
                    value={addBranchData.type}
                    onChange={(e) => handleAddChange(e)}
                  >
                    <option value="">Select cups type...</option>
                    <option value="paper"> Paper </option>
                    <option value="plastic"> Plastic </option>
                  </Form.Select>
                </Col> */}
                <Col xs={12} lg={6}>
                  <span className="edit-label">
                  PRICE LEVEL
              </span>
                  <Form.Select
                    name="price_level"
                    className="nc-modal-custom-input"
                    value={addBranchData.price_level}
                    onChange={(e) => handleAddChange(e)}
                  >
                    <option value="">Select price level...</option>
                    {priceLevel.map((data) => {
                      return <option value={data.id}>{data.name}</option>;
                    })}
                  </Form.Select>
                </Col>
                <Col xs={12} lg={6} className="mt-2 mt-lg-0">
                  <span className="edit-label">
                  INVENTORY GROUP
              </span>
                  {/* <span className="required-icon">*</span> */}
                  <Form.Select
                    name="inventory_group_id"
                    className="nc-modal-custom-input"
                    value={addBranchData.inventory_group_id}
                    onChange={(e) => handleAddChange(e)}
                  >
                    <option value="">Select inventory group...</option>
                    {inventoryGroup.map((data) => {
                      return <option value={data.id}>{data.name}</option>;
                    })}
                  </Form.Select>
                  {/* <InputError
                    isValid={isError.inventory_group_id}
                    message={"Inventory group is required"}
                  /> */}
                </Col>
              </Row>
              <Row className="mb-2">
                <Col>
                  <span className="edit-label">
                  INITIAL DRAWER
                  <span className="color-red"> *</span>
              </span>
                  <Form.Control
                    type="text"
                    name="initial_drawer"
                    value={addBranchData.initial_drawer}
                    className="nc-modal-custom-input-edit"
                    onChange={(e) => handleAddChange(e)}
                    required
                  />
                  <InputError
                    isValid={isError.initial_drawer}
                    message={"Initial drawer is required"}
                  />
                </Col>
              </Row>
              <Row className="mb-2">
                <Col xs={12} lg={3}>
                  <span className="edit-label">
                  TIN NUMBER
              </span>
                  <Form.Control
                    type="text"
                    name="tin_no"
                    value={addBranchData.tin_no}
                    className="nc-modal-custom-input-edit"
                    onChange={(e) => handleAddChange(e)}
                    required
                  />
                </Col>
                <Col xs={12} lg={3} className="mt-2 mt-lg-0">
                  <span className="edit-label">
                  BIR NUMBER
              </span>
                  <Form.Control
                    type="text"
                    name="bir_no"
                    value={addBranchData.bir_no}
                    className="nc-modal-custom-input-edit"
                    onChange={(e) => handleAddChange(e)}
                    required
                  />
                </Col>
                {addBranchData.is_franchise === "1" ? (
                  <>
                    <Col xs={12} lg={3} className="mt-2 mt-lg-0">
                      
                      <span className="edit-label">
                      FRANCHISE CONTRACT START
              </span>
                      <ReactDatePicker
                        name="contract_start"
                        className="nc-modal-custom-input-edit ps-label-content me-3 form-control"
                        placeholderText="Select Date"
                        selected={addBranchData.contract_start}
                        onChange={(date) => {
                          setAddBranchData((prev) => {
                            return { ...prev, contract_start: date };
                          });
                        }}
                      />
                    </Col>
                    <Col xs={12} lg={3} className="mt-2 mt-lg-0">
                    <span className="edit-label">
                      FRANCHISE CONTRACT END
              </span>
                      <ReactDatePicker
                        name="contract_end"
                        className="nc-modal-custom-input-edit ps-label-content me-3 form-control"
                        placeholderText="Select Date"
                        selected={addBranchData.contract_end}
                        onChange={(date) => {
                          setAddBranchData((prev) => {
                            return { ...prev, contract_end: date };
                          });
                        }}
                      />
                    </Col>
                  </>
                ) : (
                  <>
                    <Col xs={12} lg={3} className="mt-2 mt-lg-0">
                      
                      <span className="edit-label">
                      LEASE CONTRACT START
              </span>
                      <ReactDatePicker
                        name="contract_start"
                        className="nc-modal-custom-input-edit ps-label-content me-3 form-control"
                        placeholderText="Select Date"
                        selected={addBranchData.contract_start}
                        onChange={(date) => {
                          setAddBranchData((prev) => {
                            return { ...prev, contract_start: date };
                          });
                        }}
                      />
                    </Col>
                    <Col xs={12} lg={3} className="mt-2 mt-lg-0">
                    <span className="edit-label">
                      LEASE CONTRACT END
              </span>
                      <ReactDatePicker
                        name="contract_end"
                        className="nc-modal-custom-input-edit ps-label-content me-3 form-control"
                        placeholderText="Select Date"
                        selected={addBranchData.contract_end}
                        onChange={(date) => {
                          setAddBranchData((prev) => {
                            return { ...prev, contract_end: date };
                          });
                        }}
                      />
                    </Col>
                  </>
                )}
              </Row>
              <Row className="nc-modal-custom-row text-center mb-3">
                <Col>OPERATION SCHEDULE</Col>
              </Row>
              <Row className="nc-modal-custom-row">
                <Col xs={12} lg={6}>
                <span className="edit-label">
                      FROM
              </span>
                  <Form.Select
                    name="os_startDate"
                    className="nc-modal-custom-input"
                    value={addBranchData.os_startDate}
                    onChange={(e) => handleAddChange(e)}
                    required
                  >
                    <option value="monday" selected>
                      Monday
                    </option>
                    <option value="tuesday">Tuesday</option>
                    <option value="wednesday">Wednesday</option>
                    <option value="thursday">Thursday</option>
                    <option value="friday">Friday</option>
                    <option value="saturday">Saturday</option>
                    <option value="sunday">Sunday</option>
                  </Form.Select>
                </Col>
                <Col xs={12} lg={6} className="mt-2 mt-lg-0">
                <span className="edit-label">
                      TO
              </span>
                  <Form.Select
                    name="os_endDate"
                    className="nc-modal-custom-input"
                    value={addBranchData.os_endDate}
                    onChange={(e) => handleAddChange(e)}
                    required
                  >
                    {addBranchData.os_startDate === "monday" && (
                      <>
                        <option value="tuesday">Tuesday</option>
                        <option value="wednesday">Wednesday</option>
                        <option value="thursday">Thursday</option>
                        <option value="friday">Friday</option>
                        <option value="saturday">Saturday</option>
                        <option value="sunday">Sunday</option>
                      </>
                    )}
                    {addBranchData.os_startDate === "tuesday" && (
                      <>
                        <option value="wednesday">Wednesday</option>
                        <option value="thursday">Thursday</option>
                        <option value="friday">Friday</option>
                        <option value="saturday">Saturday</option>
                        <option value="sunday">Sunday</option>
                      </>
                    )}
                    {addBranchData.os_startDate === "wednesday" && (
                      <>
                        <option value="thursday">Thursday</option>
                        <option value="friday">Friday</option>
                        <option value="saturday">Saturday</option>
                        <option value="sunday">Sunday</option>
                      </>
                    )}
                    {addBranchData.os_startDate === "thursday" && (
                      <>
                        <option value="friday">Friday</option>
                        <option value="saturday">Saturday</option>
                        <option value="sunday">Sunday</option>
                      </>
                    )}
                    {addBranchData.os_startDate === "Friday" && (
                      <>
                        <option value="saturday">Saturday</option>
                        <option value="sunday">Sunday</option>
                      </>
                    )}
                    {addBranchData.os_startDate === "Saturday" && (
                      <option value="saturday">Sunday</option>
                    )}
                    {addBranchData.os_startDate === "Sunday" && <></>}
                  </Form.Select>
                </Col>
              </Row>
              <Row className="mb-2 mt-3">
                <Col xs={6} lg={3}>
                <span className="edit-label">
                      FROM
              </span>
                  <Form>
                    <ReactDatePicker
                      selected={osStartTime}
                      className="date-filter form-control"
                      onChange={(date) => setOsStartTime(date)}
                      showTimeSelect
                      showTimeSelectOnly
                      timeIntervals={15}
                      timeCaption="Time"
                      dateFormat="h:mm aa"
                    />
                  </Form>
                </Col>
                <Col xs={6} lg={3}>
                <span className="edit-label">
                      TO
              </span>
                  <Form>
                    <ReactDatePicker
                      selected={osEndTime}
                      className="date-filter form-control"
                      onChange={(date) => setOsEndTime(date)}
                      showTimeSelect
                      showTimeSelectOnly
                      timeIntervals={15}
                      timeCaption="Time"
                      dateFormat="h:mm aa"
                    />
                  </Form>
                </Col>
              </Row>
              {/* <Row className="nc-modal-custom-row">
                <Col>GRABFOOD/FOODPANDA OPERATION SCHEDULE</Col>
              </Row>
              <Row className="nc-modal-custom-row">
                <Col sm={6}>
                  FROM
                  <Form.Select
                    name="delivery_startDate"
                    className="nc-modal-custom-input"
                    value={addBranchData.delivery_startDate}
                    onChange={(e) => handleAddChange(e)}
                    required
                  >
                    <option value="monday" selected>
                      Monday
                    </option>
                    <option value="tuesday">Tuesday</option>
                    <option value="wednesday">Wednesday</option>
                    <option value="thursday">Thursday</option>
                    <option value="friday">Friday</option>
                    <option value="saturday">Saturday</option>
                    <option value="sunday">Sunday</option>
                  </Form.Select>
                </Col>
                <Col sm={6}>
                  To
                  <Form.Select
                    name="delivery_endDate"
                    className="nc-modal-custom-input"
                    value={addBranchData.delivery_endDate}
                    onChange={(e) => handleAddChange(e)}
                    required
                  >
                    {addBranchData.delivery_startDate === "monday" && (
                      <>
                        <option value="tuesday">Tuesday</option>
                        <option value="wednesday">Wednesday</option>
                        <option value="thursday">Thursday</option>
                        <option value="friday">Friday</option>
                        <option value="saturday">Saturday</option>
                        <option value="sunday">Sunday</option>
                      </>
                    )}
                    {addBranchData.delivery_startDate === "tuesday" && (
                      <>
                        <option value="wednesday">Wednesday</option>
                        <option value="thursday">Thursday</option>
                        <option value="friday">Friday</option>
                        <option value="saturday">Saturday</option>
                        <option value="sunday">Sunday</option>
                      </>
                    )}
                    {addBranchData.delivery_startDate === "wednesday" && (
                      <>
                        <option value="thursday">Thursday</option>
                        <option value="friday">Friday</option>
                        <option value="saturday">Saturday</option>
                        <option value="sunday">Sunday</option>
                      </>
                    )}
                    {addBranchData.delivery_startDate === "thursday" && (
                      <>
                        <option value="friday">Friday</option>
                        <option value="saturday">Saturday</option>
                        <option value="sunday">Sunday</option>
                      </>
                    )}
                    {addBranchData.delivery_startDate === "Friday" && (
                      <>
                        <option value="saturday">Saturday</option>
                        <option value="sunday">Sunday</option>
                      </>
                    )}
                    {addBranchData.delivery_startDate === "Saturday" && (
                      <option value="saturday">Sunday</option>
                    )}
                    {addBranchData.delivery_startDate === "Sunday" && <></>}
                  </Form.Select>
                </Col>
              </Row>

              <Row className="nc-modal-custom-row">
                <Col sm={4}>
                  FROM
                  <Form>
                    <ReactDatePicker
                      selected={deliveryStartTime}
                      onChange={(date) => setDeliveryStartTime(date)}
                      showTimeSelect
                      showTimeSelectOnly
                      timeIntervals={15}
                      timeCaption="Time"
                      dateFormat="h:mm aa"
                    />
                  </Form>
                </Col>
                <Col sm={4}>
                  To
                  <Form>
                    <ReactDatePicker
                      selected={deliveryEndTime}
                      onChange={(date) => setDeliveryEndTime(date)}
                      showTimeSelect
                      showTimeSelectOnly
                      timeIntervals={15}
                      timeCaption="Time"
                      dateFormat="h:mm aa"
                    />
                  </Form>
                </Col>
              </Row> */}

              <Row className="mb-2 mt-2">
                <Col xs={12} lg={3}>
                <span className="edit-label">
                OPENING DATE
              </span>
                  <ReactDatePicker
                    name="opening_date"
                    className="nc-modal-custom-input-edit ps-label-content me-3 form-control"
                    placeholderText="Select Date"
                    selected={addBranchData.opening_date}
                    onChange={(date) => {
                      setAddBranchData((prev) => {
                        return { ...prev, opening_date: date };
                      });
                    }}
                  />
                  {/* <Form.Control
                                        type="date"
                                        name="opening_date"
                                        value={addBranchData.opening_date}
                                        className="nc-modal-custom-input-edit"
                                        onChange={(e) => handleAddChange(e)}
                                        required
                                    /> */}
                  <InputError
                    isValid={isError.opening_date}
                    message={"Opening date is required"}
                  />
                </Col>
                <Col xs={12} lg={4} className="mt-2 mt-lg-0">
                  <span className="edit-label">
                  CONTACT PERSON
              </span>
                  <span className="required-icon">*</span>
                  <Form.Control
                    type="text"
                    name="contact_person"
                    value={addBranchData.contact_person}
                    className="nc-modal-custom-input-edit"
                    onChange={(e) => handleAddChange(e)}
                    required
                  />
                  <InputError
                    isValid={isError.contact_person}
                    message={"Contact person is required"}
                  />
                </Col>
                <Col xs={12} lg={4} className="mt-2 mt-lg-0">
                  <span className="edit-label">
                  CONTACT PERSON PHONE NUMBER
              </span>
                  <span className="required-icon">*</span>
                  <Form.Control
                    type="text"
                    name="contact_person_no"
                    value={addBranchData.contact_person_no}
                    className="nc-modal-custom-input-edit"
                    onChange={(e) => handleAddChange(e)}
                    required
                  />
                  <InputError
                    isValid={isError.contact_person_no}
                    message={"Contact person phone number is required"}
                  />
                </Col>
              </Row>
              {/* <Row className="nc-modal-custom-row">
                <Col>
                  DEPOSIT METHOD
                  <Form.Control
                    type="text"
                    name="deposit_method"
                    value={addBranchData.deposit_method}
                    className="nc-modal-custom-input-edit"
                    onChange={(e) => handleAddChange(e)}
                  />
                </Col>
                <Col>
                  BANK FOR DEPOSIT
                  <Form.Control
                    type="text"
                    name="bank_for_deposit"
                    value={addBranchData.bank_for_deposit}
                    className="nc-modal-custom-input-edit"
                    onChange={(e) => handleAddChange(e)}
                  />
                </Col>
              </Row> */}
            </>
          ) : (
            <></>
          )}
        </div>
      </AddModal>
      <EditModal
        title="BRANCH"
        type="branch"
        show={showEditBranchModal}
        onHide={handleCloseEditBranchModal}
        onSave={() => editBranch()}
        isClicked={isClicked}
      >
        <div className="mt-3">
          <Row className="mb-2">
            <Col xs={12} lg={3}>
              <span className="edit-label">
              BRANCH NAME
                  <span className="color-red"> *</span>
              </span>
              <Form.Control
                type="text"
                name="name"
                value={editBranchData.name}
                className="nc-modal-custom-input-edit"
                onChange={(e) => handleEditChange(e)}
                required
              />
              <InputError
                isValid={isError.name}
                message={"Branch name is required"}
              />
            </Col>
            <Col xs={12} lg={3} className="mt-2 mt-lg-0">
              <span className="edit-label">
              ADDRESS
                  <span className="color-red"> *</span>
              </span>
              <Form.Control
                type="text"
                name="address"
                value={editBranchData.address}
                className="nc-modal-custom-input-edit"
                onChange={(e) => handleAddChange(e)}
                required
              />
              <InputError
                isValid={isError.address}
                message={"Address is required"}
              />
            </Col>
            <Col xs={12} lg={3} className="mt-2 mt-lg-0">
              <span className="edit-label">
              PHONE NUMBER
                  <span className="color-red"> *</span>
              </span>
              <Form.Control
                type="text"
                name="phone_no"
                value={editBranchData.phone_no}
                className="nc-modal-custom-input-edit"
                onChange={(e) => handleEditChange(e)}
                required
              />
              <InputError
                isValid={isError.phone_no}
                message={"Phone number is required"}
              />
            </Col>
            <Col xs={12} lg={3} className="mt-2 mt-lg-0">
              <span className="edit-label">
              STATUS
              </span>
              <select
                className="nc-modal-custom-select"
                name="status"
                defaultValue={editBranchData.status}
                onChange={(e) => handleEditChange(e)}
              >
                <option value="" hidden>
                  Select
                </option>
                <option value="active">Active</option>
                <option value="inactive">Inactive</option>
              </select>
            </Col>
          </Row>
          <Row className="mb-2">
            <Col xs={12} lg={6}>
            <span className="edit-label">
            OIC
              </span>
              {/* <span className="required-icon">*</span> */}
              <Select
                  className="react-select-container"
                  classNamePrefix="react-select"
                  placeholder="Select OIC..."
                  value={editBranchData.oic_id_value}
                  options={allOIC}
                  onChange={(e) =>
                      handleEditChange(e, "select")
                  }
              />
            </Col>
            <Col xs={12} lg={6} className="mt-2 mt-lg-0">
            <span className="edit-label">
            ICC
              </span>
              {/* <span className="required-icon">*</span> */}
              <Select
                  className="react-select-container"
                  classNamePrefix="react-select"
                  placeholder="Select OIC..."
                  value={editBranchData.icc_id_value}
                  options={allIcc}
                  onChange={(e) =>
                      handleEditChange(e, "select")
                  }
              />
            </Col>
          </Row>
          {addTo !== "POTATO CORNER" && (
            <>
              <Row>
                <Col>
                  <span className="edit-label">
                  BRANCH TYPE
                  <span className="color-red"> *</span>
              </span>
                  <InputError
                    isValid={isError.is_franchise}
                    message={"Branch type is required"}
                  />
                </Col>
              </Row>
              <Row className="mb-2">
                {/* <Col xl={3} className="nc-modal-custom-row-details">
                  <input
                    type="radio"
                    name="is_franchise"
                    value="1"
                    className=""
                    onChange={(e) => handleAddChange(e)}
                    required
                  />
                  <span className="radio-label">FRANCHISE</span>
                </Col> */}
                <Col xl={3}>
                  <input
                    type="radio"
                    name="is_franchise"
                    value="0"
                    className=""
                    onChange={(e) => handleAddChange(e)}
                    checked={editBranchData.is_franchise === "0"}
                    required
                  />
                  <span className="radio-label">COMPANY-OWNED</span>
                </Col>
                <Col xl={3} className="nc-modal-custom-row-details">
                  <input
                    type="radio"
                    name="is_franchise"
                    value="2"
                    className=""
                    checked={editBranchData.is_franchise === "2"}
                    onChange={(e) => handleAddChange(e)}
                    required
                  />
                  <span className="radio-label">OTHERS</span>
                </Col>
              </Row>
            </>
          )}
          {addBranchData.is_franchise === "0" && (
            <Row className="mb-2">
              <Col>
                <span className="edit-label">
                MONTHLY RENTAL FEE
                  <span className="color-red"> *</span>
              </span>
              <Form.Control
                  type="text"
                  name="rental_monthly_fee"
                  value={editBranchData.rental_monthly_fee}
                  className="nc-modal-custom-input-edit"
                  onChange={(e) => handleEditChange(e)}
                  required
                />
                <InputError
                  isValid={isError.rental_monthly_fee}
                  message={"Monthly rental fee is required"}
                />
              </Col>
            </Row>
          )}
          {addBranchData.is_franchise !== "2" ? (
            <>
              <Row className="mb-2">
                {/* <Col>
                  CUPS TYPE
                  <Form.Select
                    name="type"
                    className="nc-modal-custom-input"
                    value={addBranchData.type}
                    onChange={(e) => handleAddChange(e)}
                  >
                    <option value="">Select cups type...</option>
                    <option value="paper"> Paper </option>
                    <option value="plastic"> Plastic </option>
                  </Form.Select>
                </Col> */}
                <Col xs={12} lg={6}>
                  <span className="edit-label">
                  PRICE LEVEL
              </span>
              <Form.Select
                    name="price_level"
                    className="nc-modal-custom-input"
                    value={editBranchData.price_level}
                    onChange={(e) => handleEditChange(e)}
                  >
                    <option value="">Select price level...</option>
                    {priceLevel.map((data) => {
                      return <option value={data.id}>{data.name}</option>;
                    })}
                  </Form.Select>
                </Col>
                <Col xs={12} lg={6} className="mt-2 mt-lg-0">
                  <span className="edit-label">
                  INVENTORY GROUP
              </span>
                  {/* <span className="required-icon">*</span> */}
                  <Form.Select
                    name="inventory_group_id"
                    className="nc-modal-custom-input"
                    value={editBranchData.inventory_group_id}
                    onChange={(e) => handleEditChange(e)}
                  >
                    <option value="">Select inventory group...</option>
                    {inventoryGroup.map((data) => {
                      return <option value={data.id}>{data.name}</option>;
                    })}
                  </Form.Select>
                  {/* <InputError
                    isValid={isError.inventory_group_id}
                    message={"Inventory group is required"}
                  /> */}
                </Col>
              </Row>
              <Row className="mb-2">
                <Col>
                  <span className="edit-label">
                  INITIAL DRAWER
                  <span className="color-red"> *</span>
              </span>
              <Form.Control
                    type="text"
                    name="initial_drawer"
                    value={editBranchData.initial_drawer}
                    className="nc-modal-custom-input-edit"
                    onChange={(e) => handleEditChange(e)}
                    required
                  />
                  <InputError
                    isValid={isError.initial_drawer}
                    message={"Initial drawer is required"}
                  />
                </Col>
              </Row>
              <Row className="mb-2">
                <Col xs={12} lg={3}>
                  <span className="edit-label">
                  TIN NUMBER
              </span>
              <Form.Control
                    type="text"
                    name="tin_no"
                    value={editBranchData.tin_no}
                    className="nc-modal-custom-input-edit"
                    onChange={(e) => handleEditChange(e)}
                    required
                  />
                </Col>
                <Col xs={12} lg={3} className="mt-2 mt-lg-0">
                  <span className="edit-label">
                  BIR NUMBER
              </span>
              <Form.Control
                    type="text"
                    name="bir_no"
                    value={editBranchData.bir_no}
                    className="nc-modal-custom-input-edit"
                    onChange={(e) => handleEditChange(e)}
                    required
                  />
                </Col>
                {addBranchData.is_franchise === "1" ? (
                  <>
                    <Col xs={12} lg={3} className="mt-2 mt-lg-0">
                      
                      <span className="edit-label">
                      FRANCHISE CONTRACT START
              </span>
                      <ReactDatePicker
                        name="contract_start"
                        className="nc-modal-custom-input-edit ps-label-content me-3 form-control"
                        selected={
                          editBranchData?.contract_start !== "0000-00-00"
                            ? new Date(editBranchData.contract_start)
                            : ""
                        }
                        disabled
                      />
                    </Col>
                    <Col xs={12} lg={3} className="mt-2 mt-lg-0">
                    <span className="edit-label">
                      FRANCHISE CONTRACT END
              </span>
                      <ReactDatePicker
                        name="contract_end"
                        className="nc-modal-custom-input-edit ps-label-content me-3 form-control"
                        selected={
                          editBranchData?.contract_end !== "0000-00-00"
                            ? new Date(editBranchData.contract_end)
                            : ""
                        }
                        disabled
                      />
                    </Col>
                  </>
                ) : (
                  <>
                    <Col xs={12} lg={3} className="mt-2 mt-lg-0">
                      
                      <span className="edit-label">
                      LEASE CONTRACT START
              </span>
                      <ReactDatePicker
                        name="contract_start"
                        className="nc-modal-custom-input-edit ps-label-content me-3 form-control"
                        selected={
                          editBranchData?.contract_start !== "0000-00-00"
                            ? new Date(editBranchData.contract_start)
                            : ""
                        }
                        placeholderText="Select Date"
                        onChange={(date) => {
                          setEditBranchData((prev) => {
                            return { ...prev, contract_start: date };
                          });
                        }}
                      />
                    </Col>
                    <Col xs={12} lg={3} className="mt-2 mt-lg-0">
                    <span className="edit-label">
                      LEASE CONTRACT END
              </span>
                <ReactDatePicker
                        name="contract_end"
                        className="nc-modal-custom-input-edit ps-label-content me-3 form-control"
                        selected={
                          editBranchData?.contract_end !== "0000-00-00"
                            ? new Date(editBranchData.contract_end)
                            : ""
                        }
                        placeholderText="Select Date"
                        onChange={(date) => {
                          setEditBranchData((prev) => {
                            return { ...prev, contract_end: date };
                          });
                        }}
                      />
                    </Col>
                  </>
                )}
              </Row>
              <Row className="nc-modal-custom-row text-center mb-3">
                <Col>OPERATION SCHEDULE</Col>
              </Row>
              <Row className="nc-modal-custom-row">
                <Col xs={12} lg={6}>
                <span className="edit-label">
                      FROM
              </span>
              <Form.Select
                    name="os_startDate"
                    className="nc-modal-custom-input"
                    value={editBranchData.os_startDate}
                    onChange={(e) => handleEditChange(e)}
                    required
                  >
                    <option value="monday" selected>
                      Monday
                    </option>
                    <option value="tuesday">Tuesday</option>
                    <option value="wednesday">Wednesday</option>
                    <option value="thursday">Thursday</option>
                    <option value="friday">Friday</option>
                    <option value="saturday">Saturday</option>
                    <option value="sunday">Sunday</option>
                  </Form.Select>
                </Col>
                <Col xs={12} lg={6} className="mt-2 mt-lg-0">
                <span className="edit-label">
                      TO
              </span>
              <Form.Select
                    name="os_endDate"
                    className="nc-modal-custom-input"
                    value={editBranchData.os_endDate}
                    onChange={(e) => handleEditChange(e)}
                    required
                  >
                    <option value="monday"> Monday</option>
                    <option value="tuesday">Tuesday</option>
                    <option value="wednesday">Wednesday</option>
                    <option value="thursday">Thursday</option>
                    <option value="friday">Friday</option>
                    <option value="saturday">Saturday</option>
                    <option value="sunday">Sunday</option>
                  </Form.Select>
                </Col>
              </Row>
              <Row className="mb-2 mt-3">
                <Col xs={6} lg={3}>
                <span className="edit-label">
                      FROM
              </span>
                  <Form>
                    <ReactDatePicker
                      selected={osStartTimeEdit}
                      className="date-filter form-control"
                      onChange={(date) => setOsStartTimeEdit(date)}
                      showTimeSelect
                      showTimeSelectOnly
                      timeIntervals={15}
                      timeCaption="Time"
                      dateFormat="h:mm aa"
                    />
                  </Form>
                </Col>
                <Col xs={6} lg={3}>
                <span className="edit-label">
                      TO
              </span>
                <Form>
                    <ReactDatePicker
                      selected={osEndTimeEdit}
                      className="date-filter form-control"
                      onChange={(date) => setOsEndTimeEdit(date)}
                      showTimeSelect
                      showTimeSelectOnly
                      timeIntervals={15}
                      timeCaption="Time"
                      dateFormat="h:mm aa"
                    />
                  </Form>
                </Col>
              </Row>

              <Row className="mb-2 mt-2">
                <Col xs={12} lg={3}>
                <span className="edit-label">
                OPENING DATE
              </span>
                <ReactDatePicker
                    name="opening_date"
                    className="nc-modal-custom-input-edit ps-label-content me-3 form-control"
                    selected={
                      editBranchData?.opening_date !== "0000-00-00"
                        ? new Date(editBranchData.opening_date)
                        : new Date()
                    }
                    onChange={(date) => {
                      setEditBranchData((prev) => {
                        return { ...prev, opening_date: date };
                      });
                    }}
                  />
                  {/* <Form.Control
                                        type="date"
                                        name="opening_date"
                                        value={addBranchData.opening_date}
                                        className="nc-modal-custom-input-edit"
                                        onChange={(e) => handleAddChange(e)}
                                        required
                                    /> */}
                  <InputError
                    isValid={isError.opening_date}
                    message={"Opening date is required"}
                  />
                </Col>
                <Col xs={12} lg={4} className="mt-2 mt-lg-0">
                  <span className="edit-label">
                  CONTACT PERSON
              </span>
                  <span className="required-icon">*</span>
                  <Form.Control
                    type="text"
                    name="contact_person"
                    value={editBranchData.contact_person}
                    className="nc-modal-custom-input-edit"
                    onChange={(e) => handleEditChange(e)}
                    required
                  />
                  <InputError
                    isValid={isError.contact_person}
                    message={"Contact person is required"}
                  />
                </Col>
                <Col xs={12} lg={4} className="mt-2 mt-lg-0">
                  <span className="edit-label">
                  CONTACT PERSON PHONE NUMBER
              </span>
                  <span className="required-icon">*</span>
                  <Form.Control
                    type="text"
                    name="contact_person_no"
                    value={editBranchData.contact_person_no}
                    className="nc-modal-custom-input-edit"
                    onChange={(e) => handleEditChange(e)}
                    required
                  />
                  <InputError
                    isValid={isError.contact_person_no}
                    message={"Contact person phone number is required"}
                  />
                </Col>
              </Row>
              {/* <Row className="nc-modal-custom-row">
                <Col>
                  DEPOSIT METHOD
                  <Form.Control
                    type="text"
                    name="deposit_method"
                    value={addBranchData.deposit_method}
                    className="nc-modal-custom-input-edit"
                    onChange={(e) => handleAddChange(e)}
                  />
                </Col>
                <Col>
                  BANK FOR DEPOSIT
                  <Form.Control
                    type="text"
                    name="bank_for_deposit"
                    value={addBranchData.bank_for_deposit}
                    className="nc-modal-custom-input-edit"
                    onChange={(e) => handleAddChange(e)}
                  />
                </Col>
              </Row> */}
            </>
          ) : (
            <></>
          )}
        </div>
      </EditModal>
      <ViewModal
        withButtons
        show={showViewBranchModal}
        onHide={handleCloseViewBranchModal}
        onEdit={handleOnEdit}
        withOutEdit={withOutEdit}
      >
        <div className="mt-3">
          <span className="custom-modal-body-title-branch-details">
            {renderBranchType(selectedRow.is_franchise)}
          </span>
          <div className="mt-3 container-wrapper">
            <Row className="nc-modal-custom-row black mt-0">
              <Col xs={12} lg={3} className="mb-1 mt-lg-0">
                BRANCH NAME
                <span className="required-icon">*</span>
                <Row className="nc-modal-custom-row">
                  <Col> {selectedRow.name || "N/A"} </Col>
                </Row>
              </Col>
              <Col xs={12} lg={3} className="mb-1 mt-lg-0">
                ADDRESS
                <span className="required-icon">*</span>
                <Row className="nc-modal-custom-row">
                  <Col> {selectedRow.address || "N/A"} </Col>
                </Row>
              </Col>
              <Col xs={12} lg={3} className="mb-1 mt-lg-0">
                PHONE NUMBER
                <span className="required-icon">*</span>
                <Row className="nc-modal-custom-row">
                  <Col> {selectedRow.phone_no || "N/A"} </Col>
                </Row>
              </Col>
            </Row>
            <Row className="nc-modal-custom-row black mt-0">
              <Col xs={12} lg={3} className="mb-1 mt-lg-0">
                OIC
                {/* <span className="required-icon">*</span> */}
                <Row className="nc-modal-custom-row">
                  <Col> {selectedRow.oic_name || "N/A"} </Col>
                </Row>
              </Col>
              <Col xs={12} lg={3} className="mb-1 mt-lg-0">
                ICC
                {/* <span className="required-icon">*</span> */}
                <Row className="nc-modal-custom-row">
                  <Col> {selectedRow.icc_name || "N/A"} </Col>
                </Row>
              </Col>
            </Row>
            {selectedRow.is_franchise !== "2" ? (
              <>
                <Row className="nc-modal-custom-row black">
                  {/* <Col>
                    CUPS TYPE
                    <Row className="nc-modal-custom-row">
                      <Col> {selectedRow.type || "N/A"} </Col>
                    </Row>
                  </Col> */}
                  <Col xs={12} lg={6} className="mb-1 mt-lg-0">
                    PRICE LEVEL
                    <Row className="nc-modal-custom-row">
                      <Col> {selectedRow.price_level_name || "N/A"} </Col>
                    </Row>
                  </Col>
                  <Col xs={12} lg={6} className="mb-1 mt-lg-0">
                    INVENTORY GROUP
                    <Row className="nc-modal-custom-row">
                      <Col> {selectedRow.inventory_group || "N/A"} </Col>
                    </Row>
                  </Col>
                </Row>
                <Row className="nc-modal-custom-row black">
                  {selectedRow.is_franchise === "0" && (
                    <Col xl={3}>
                      MONTHLY RENTAL FEE
                      <span className="required-icon">*</span>
                      <Row className="nc-modal-custom-row">
                        <Col> {selectedRow.rental_monthly_fee || "N/A"} </Col>
                      </Row>
                    </Col>
                  )}
                  <Col xl={3}>
                    INITIAL DRAWER
                    <Row className="nc-modal-custom-row">
                      <Col>
                        {" "}
                        {selectedRow.initial_drawer
                          ? numberFormat(selectedRow.initial_drawer)
                          : "N/A"}{" "}
                      </Col>
                    </Row>
                  </Col>
                  <Col xl={3} className="nc-modal-custom-row-details">
                    TIN NUMBER
                    <Row className="nc-modal-custom-row">
                      <Col> {selectedRow.tin_no || "N/A"} </Col>
                    </Row>
                  </Col>
                  <Col xl={3} className="nc-modal-custom-row-details">
                    BIR NUMBER
                    <Row className="nc-modal-custom-row">
                      <Col> {selectedRow.bir_no || "N/A"} </Col>
                    </Row>
                  </Col>
                </Row>
                <Row className="nc-modal-custom-row black">
                  {selectedRow.is_franchise === "1" ? (
                    <>
                      <Col xl={3} className="nc-modal-custom-row-details">
                        FRANCHISE CONTRACT START
                        <Row className="nc-modal-custom-row">
                          <Col> {selectedRow.contract_start || "N/A"} </Col>
                        </Row>
                      </Col>
                      <Col xl={3} className="nc-modal-custom-row-details">
                        FRANCHISE CONTRACT END
                        <Row className="nc-modal-custom-row">
                          <Col> {selectedRow.contract_end || "N/A"} </Col>
                        </Row>
                      </Col>
                    </>
                  ) : (
                    <>
                      <Col xl={3} className="nc-modal-custom-row-details">
                        LEASE CONTRACT START
                        <Row className="nc-modal-custom-row">
                          <Col> {selectedRow.contract_start || "N/A"} </Col>
                        </Row>
                      </Col>
                      <Col xl={3} className="nc-modal-custom-row-details">
                        LEASE CONTRACT END
                        <Row className="nc-modal-custom-row">
                          <Col> {selectedRow.contract_end || "N/A"} </Col>
                        </Row>
                      </Col>
                    </>
                  )}
                  <Col xl={3} className="nc-modal-custom-row-details">
                    OPENING DATE
                    <Row className="nc-modal-custom-row">
                      <Col> {selectedRow.opening_date || "N/A"} </Col>
                    </Row>
                  </Col>
                </Row>
                <Row className="nc-modal-custom-row black">
                  <Col>
                    OPERATION SCHEDULE
                    <Row className="nc-modal-custom-row">
                      <Col>
                        {" "}
                        {selectedRow?.operation_days +
                          " " +
                          selectedRow?.operation_times || "N/A"}{" "}
                      </Col>
                    </Row>
                  </Col>
                  {/* <Col>
                    GRABFOOD/FOODPANDA OPERATION SCHEDULE
                    <Row className="nc-modal-custom-row">
                      <Col>
                        {" "}
                        {selectedRow?.delivery_days +
                          " " +
                          selectedRow?.delivery_times || "N/A"}{" "}
                      </Col>
                    </Row>
                  </Col> */}
                </Row>
                {/* <Row className="nc-modal-custom-row black">
                  <Col>
                    DEPOSIT METHOD
                    <Row className="nc-modal-custom-row">
                      <Col> {selectedRow.deposit_method || "N/A"} </Col>
                    </Row>
                  </Col>
                  <Col>
                    BANK FOR DEPOSIT
                    <Row className="nc-modal-custom-row">
                      <Col> {selectedRow.bank_for_deposit || "N/A"} </Col>
                    </Row>
                  </Col>
                </Row> */}
              </>
            ) : (
              <></>
            )}
          </div>
          {(selectedRow.is_franchise === "0" ||
            selectedRow.is_franchise === "1") && (
            <div className="col-sm-12 mt-3 space">
              <span className="custom-modal-body-title-contact-info">
                CONTACT INFORMATION
              </span>
              <div className="mt-3 container-wrapper">
                <Row className="nc-modal-custom-row-view">
                  <Col xs={12} lg={3} className="mb-1 mt-lg-0">
                    CONTACT PERSON
                    <Row className="nc-modal-custom-row">
                      <Col>{selectedRow.contact_person}</Col>
                    </Row>
                  </Col>
                  <Col xs={12} lg={3} className="mb-1 mt-lg-0">
                    PHONE NUMBER
                    <Row className="nc-modal-custom-row">
                      <Col>{selectedRow.contact_person_no}</Col>
                    </Row>
                  </Col>
                </Row>
              </div>
            </div>
          )}
        </div>
      </ViewModal>
      <Footer/>
    </div>
  );
}